import {
    Dialog, DialogContent, DialogTitle, IconButton,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import PTMBottomAppBar from "./PTMBottomAppBar";

export default function PTMConfirmDialog(props) {
    const {
        title,
        children,
        open,
        confirmText,
        denyText,
        setOpen,
        onConfirm,
        onClose,
        hideCancelButton,
        noActionOnBackdropClick,
        noActionOnEsc,
    } = props;

    const innerOnClose = (e, reason) => {
        let dontClose = false;

        if (reason === "backdropClick" && noActionOnBackdropClick) {
            dontClose = true;
        }

        if (reason === "escapeKeyDown" && noActionOnEsc) {
            dontClose = true;
        }

        if (!dontClose) {
            if (onClose) onClose();
            if (setOpen) setOpen(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={(e, reason) => innerOnClose(e, reason)}
            aria-labelledby="confirm-dialog"
        >
            <DialogTitle id="confirm-dialog" style={{ padding: "8px 24px 8px 8px" }}>
                {title}
                <IconButton
                    size="medium"
                    onClick={() => innerOnClose()}
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </IconButton>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <PTMBottomAppBar
                buttons={[
                    {
                        name: confirmText || "Ok",
                        icon: "check",
                        click: async () => {
                            await onConfirm();
                            if (setOpen) setOpen(false);
                        },
                    },
                    ...!hideCancelButton ? [
                        {
                            name: denyText || "Abbrechen",
                            icon: "times",
                            click: () => innerOnClose(),
                            color: "error",
                        },
                    ] : [],
                ]}
            />
        </Dialog>
    );
}
